import React, { useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { addDays, addMonths, differenceInDays } from 'date-fns';
import { toast } from 'react-toastify';
import { ChaveDispositivo, ChaveVencimento, ClienteModel } from '../../util/Models';
import ClienteService from '../../services/ClienteService';
import LabelSp from '../../components/LabelSp';
import DropdownSp from '../../components/DropdownSp';
import InputCurrencySp from '../../components/InputCurrencySp';
import CalendarSp from '../../components/CalendarSp';
import { cfgPtBr } from '../../config/Constantes';
import {
  errorHandle,
  formatDate,
  isDate,
  isScreenMobile,
  newDateOnly,
  strToDate,
} from '../../util/functions';

import ButtonSp from '../../components/ButtonSp';
import InputTextareaSp from '../../components/InputTextareaSp';
import InputTextSp from '../../components/InputTextSp';
import ChaveAdmService from '../../services/ChaveAdmService';
import ChaveService from '../../services/ChaveService';
import DispositivoService from '../../services/DispositivoService';
import { showMessage } from '../../components/MessageDialog';
import AuthService from '../../services/AuthService';

function ChaveAdm(props) {
  ChaveAdm.propTypes = {
    numeroContrato: PropTypes.string,
    vencimentoChaveAtual: PropTypes.any,
    numeroDebitos: PropTypes.number,
    inativo: PropTypes.bool,
  };

  const { numeroContrato, vencimentoChaveAtual, numeroDebitos, inativo } = props;
  const [chaveVencimento, setChaveVencimento] = useState(new ChaveVencimento());
  const [descricaoModulos, setDescricaoModulos] = useState('');
  const [vencimentoOriginal, setVencimentoOriginal] = useState(new Date());
  const [chaveGerada, setChaveGerada] = useState(new ChaveVencimento());
  const [chaveDispositivo, setChaveDispositivo] = useState(new ChaveDispositivo());
  const qtdDebitos = numeroDebitos || 0;

  const prorrogarVencimento = useCallback(() => {
    if (vencimentoChaveAtual && differenceInDays(vencimentoChaveAtual, newDateOnly()) >= 0) {
      toast.error('Chave deve estar vencida para ser prorrogada');
      return;
    }

    // if (differenceInDays(new Date(), vencimentoOriginal) > 5) {
    //   const dataProrrogar = addDays(new Date(), -5 + 2);
    //   setChaveVencimento({ ...chaveVencimento, vencimento: dataProrrogar });
    // } else {
    //   const dataProrrogar = addDays(vencimentoOriginal, 2);
    //   setChaveVencimento({ ...chaveVencimento, vencimento: dataProrrogar });
    // }

    const dataProrrogar = calculaVencimentoProrrogacao(vencimentoOriginal);
    setChaveVencimento({ ...chaveVencimento, vencimento: dataProrrogar });
  }, [chaveVencimento, vencimentoChaveAtual, vencimentoOriginal]);

  const calculaVencimentoProrrogacao = vencOriginal => {
    if (differenceInDays(new Date(), vencOriginal) > 5) {
      return addDays(new Date(), -5 + 2);
    }
    return addDays(vencOriginal, 2);
  };
  const confirmaGerarChave = async () => {
    let prorrogacao20Dias = false;
    prorrogacao20Dias = await ChaveAdmService.checkProrrogacao(numeroContrato);
    let msg = 'Existe débitos para este cliente. Confirma os operaçao assim mesmo?';
    if (prorrogacao20Dias) {
      msg =
        'Existe prorrogação realizada para o cliente nos últimos 20 dias. Confirma os operaçao assim mesmo?';
    }

    if (qtdDebitos !== 0 || prorrogacao20Dias) {
      showMessage('Confirmação', msg, idx => {
        if (idx === 1) {
          gerarChave();
        }
      });
    } else if (inativo) {
      showMessage('Confirmação', 'Cliente inativo. Confirma os operaçao assim mesmo?', idx => {
        if (idx === 1) {
          gerarChave();
        }
      });
    } else {
      gerarChave();
    }
  };
  const gerarChave = useCallback(async () => {
    if (!chaveVencimento.numeroContrato) {
      toast.error('Informe o contrato');
      return;
    }

    if (chaveVencimento.edicao === undefined) {
      toast.error('Informe a edição');
      return;
    }

    if (!chaveVencimento.qtdDispositivos) {
      toast.error('Informe o número de dispositivo');
      return;
    }

    if (isDate(chaveVencimento.vencimento)) {
      toast.error('Informe o vencimento');
      return;
    }

    try {
      const ret = await ChaveAdmService.chaveVencimento(chaveVencimento);
      setChaveGerada(ret);
    } catch (err) {
      errorHandle(err);
    }
  }, [chaveVencimento]);

  const gerarChaveDispositivo = useCallback(async () => {
    if (!chaveDispositivo.chaveDispositivo) {
      toast.error('Informe a chave do dispositivo');
      return;
    }

    try {
      const ret = await ChaveAdmService.contraChaveDispositivo({
        chaveDispositivo: chaveDispositivo.chaveDispositivo,
        justificativa: chaveDispositivo.justificativa,
      });
      setChaveDispositivo({ ...ret, justificativa: chaveDispositivo.justificativa });
    } catch (err) {
      errorHandle(err);
    }
  }, [chaveDispositivo.chaveDispositivo, chaveDispositivo.justificativa]);

  const salvaChaveVencimento = useCallback(async () => {
    if (!chaveGerada.numeroContrato || !chaveGerada.chaveLiberacao) {
      toast.error('Chave de liberação inválida');
      return;
    }

    if (isDate(chaveGerada.vencimento)) {
      toast.error('Informe o vencimento');
      return;
    }

    if (chaveGerada.numeroContrato === '180002') {
      toast.error('Não é permitido salvar chave para contrato demonstração');
      return;
    }

    try {
      await ChaveService.sincronizaChave(chaveGerada);
      toast.success('Processo concluído');
    } catch (err) {
      errorHandle(err);
    }
  }, [chaveGerada]);

  const salvaChaveDispositivo = useCallback(async () => {
    if (!chaveDispositivo.numeroContrato || !chaveDispositivo.md5) {
      toast.error('Chave de dispositovo e/ou contra chave inválida');
      return;
    }

    if (chaveDispositivo.numeroContrato === '180002') {
      toast.error('Não é permitido salvar chave para contrato demonstração');
      return;
    }

    try {
      await DispositivoService.sincronizaChave({
        numeroContrato: chaveDispositivo.numeroContrato,
        chaveDispositivo: chaveDispositivo.md5,
      });
      toast.success('Processo concluído');
    } catch (err) {
      errorHandle(err);
    }
  }, [chaveDispositivo.md5, chaveDispositivo.numeroContrato]);

  useEffect(() => {
    const loadAsync = async () => {
      let clienteRet = new ClienteModel();
      let chaveVencimentoRet = new ChaveVencimento();
      const mesAtual = formatDate(new Date(), 'yyyy-MM');

      if (numeroContrato) {
        try {
          setChaveGerada(new ChaveVencimento());
          clienteRet = await ClienteService.findByContrato(numeroContrato);
          const { edicao, numeroDispositivos, diaVencimento } = clienteRet;
          let vencimento = strToDate(`${mesAtual}-${diaVencimento}`);
          let vencOriginal;
          if (
            vencimentoChaveAtual &&
            differenceInDays(newDateOnly(), vencimentoChaveAtual) > 0
          ) {
            vencOriginal = vencimentoChaveAtual;
            setVencimentoOriginal(vencimentoChaveAtual);
          } else {
            vencOriginal = vencimento;
            setVencimentoOriginal(vencimento);
          }

          if (vencimento.getDate() <= new Date().getDate()) {
            vencimento = addMonths(vencimento, 1);
          }

          if (
            (!AuthService.checkRoles('CHAVE_GERAR_VENCIMENTO') &&
              AuthService.checkRoles('CHAVE_PRORROGAR_VENCIMENTO')) ||
            qtdDebitos > 0
          ) {
            vencimento = calculaVencimentoProrrogacao(vencOriginal);
          }
          const modulos = {};

          let descModulos = '';
          if (Array.isArray(clienteRet.modulos)) {
            clienteRet.modulos.forEach(e => {
              descModulos += `, ${e.modulo?.descricao}`;
            });
          }

          if (descModulos !== '') {
            descModulos = descModulos.substring(1);
          }
          descModulos = descModulos.trim();

          setDescricaoModulos(descModulos);

          Object.keys(clienteRet).forEach(e => {
            if (e.includes('modAdicional') || e.includes('modEscritaFiscal')) {
              modulos[e] = clienteRet[e];
            }
          });

          chaveVencimentoRet = {
            numeroContrato,
            vencimento,
            edicao,
            qtdDispositivos: numeroDispositivos,
            modulos,
          };
        } catch (error) {
          //
        }
      }

      setChaveVencimento(chaveVencimentoRet);

      // setCliente(clienteRet);
    };

    loadAsync();
  }, [numeroContrato, qtdDebitos, vencimentoChaveAtual]);

  return (
    <div className="p-grid">
      {AuthService.checkRoles(['CHAVE_GERAR_VENCIMENTO']) ||
      AuthService.checkRoles(['CHAVE_PRORROGAR_VENCIMENTO']) ? (
        <>
          <div className="p-col-12 div-result">
            <span className="result">Chave ADM (Vencimento)</span>
          </div>

          <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
            <LabelSp>Edição</LabelSp>
            <DropdownSp
              options={[
                { label: 'Business', value: 0 },
                { label: 'Professional', value: 1 },
                { label: 'Lite', value: 2 },
                { label: 'Nfe', value: 3 },
              ]}
              required
              disabled
              value={chaveVencimento.edicao}
              onChange={e =>
                setChaveVencimento({ ...chaveVencimento, edicao: e.target.value })
              }
            />
          </div>

          <div className="p-col-3 p-md-2 p-lg-2 p-fluid">
            <LabelSp>Nr. Disp.</LabelSp>
            <InputCurrencySp
              digits={0}
              required
              disabled
              name="qtdDispositivos"
              value={chaveVencimento.qtdDispositivos}
              onChange={(e, v) => {
                setChaveVencimento({
                  ...chaveVencimento,
                  qtdDispositivos: v,
                });
              }}
            />
          </div>

          <div className="p-col-5 p-md-3 p-lg-3 p-fluid">
            <LabelSp>Vencimento</LabelSp>
            <CalendarSp
              showOnFocus={false}
              showIcon
              disabled={!AuthService.checkRoles('CHAVE_GERAR_VENCIMENTO')}
              required
              locale={cfgPtBr}
              dateFormat="dd/mm/yy"
              value={chaveVencimento.vencimento}
              appendTo={window.body}
              onChange={e => {
                setChaveVencimento({
                  ...chaveVencimento,
                  vencimento: e.target.value,
                });
              }}
            />
          </div>
          {AuthService.checkRoles('CHAVE_GERAR_VENCIMENTO') && (
            <div className="p-col-4 p-md-2 p-lg-2" style={{ textAlign: 'start' }}>
              <LabelSp style={{ display: 'block' }}>&#160;</LabelSp>
              <ButtonSp
                icon="pi pi-refresh"
                label="Prorrogar"
                className="p-button-secondary buttons"
                onClick={() => prorrogarVencimento()}
              />
            </div>
          )}

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Justificativa</LabelSp>
            <InputTextareaSp
              rows={isScreenMobile() ? 4 : 2}
              resize={false}
              value={chaveVencimento.justificativa}
              onChange={e => {
                setChaveVencimento({
                  ...chaveVencimento,
                  justificativa: e.target.value,
                });
              }}
            />
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Módulos</LabelSp>
            <InputTextareaSp
              rows={isScreenMobile() ? 8 : 4}
              resize={false}
              value={descricaoModulos || ''}
              disabled
            />
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <hr />
          </div>
          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Chave Gerada</LabelSp>
            <InputTextSp value={chaveGerada.chaveLiberacao || ''} disabled />
          </div>

          <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
            <ButtonSp
              className="p-button-success"
              icon="pi pi-cog"
              label={
                AuthService.checkRoles('CHAVE_GERAR_VENCIMENTO')
                  ? 'Gerar Chave'
                  : 'Prorrogar Chave'
              }
              keyAccess=""
              onClick={() => {
                confirmaGerarChave();
              }}
            />

            <ButtonSp
              className="p-button"
              label="Salvar no Server"
              showConfirmation
              icon="pi pi-save"
              onClick={() => {
                salvaChaveVencimento();
              }}
            />
          </div>
        </>
      ) : null}

      {AuthService.checkRoles(['CHAVE_GERAR_DISPOSITIVO']) && (
        <>
          <div className="p-col-12 div-result">
            <span className="result">Chave ADM (Dispositivos)</span>
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Chave Dispositivo</LabelSp>
            <InputTextSp
              required
              value={chaveDispositivo.chaveDispositivo || ''}
              onChange={e =>
                setChaveDispositivo({ ...chaveDispositivo, chaveDispositivo: e.target.value })
              }
            />
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Justificativa</LabelSp>
            <InputTextareaSp
              rows={isScreenMobile() ? 4 : 2}
              resize={false}
              value={chaveDispositivo.justificativa}
              onChange={e => {
                setChaveDispositivo({
                  ...chaveDispositivo,
                  justificativa: e.target.value,
                });
              }}
            />
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <hr />
          </div>
          <div className="p-col-6 p-md-4 p-lg-4 p-fluid">
            <LabelSp>Número Contrato</LabelSp>
            <InputTextSp value={chaveDispositivo.numeroContrato || ''} disabled />
          </div>

          <div className="p-col-6 p-md-4 p-lg-4 p-fluid">
            <LabelSp>Serial HD</LabelSp>
            <InputTextSp value={chaveDispositivo.hd || ''} disabled />
          </div>

          <div className="p-col-6 p-md-4 p-lg-4 p-fluid">
            <LabelSp>Processador</LabelSp>
            <InputTextSp value={chaveDispositivo.processador || ''} disabled />
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Contra chave Gerada</LabelSp>
            <InputTextSp value={chaveDispositivo.contraChaveDispositivo || ''} disabled />
          </div>

          <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
            <ButtonSp
              className="p-button-success"
              icon="pi pi-cog"
              label="Gerar Chave"
              keyAccess="G"
              onClick={() => {
                gerarChaveDispositivo();
              }}
            />

            <ButtonSp
              className="p-button"
              label="Salvar no Server"
              showConfirmation
              icon="pi pi-save"
              onClick={() => {
                salvaChaveDispositivo();
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default ChaveAdm;
